import { useTheme } from 'styled-components';

import { Modal } from '@/core/components/Modal/Modal';
import { OverlayStyle } from '@/core/components/Modal/Modal.types';
import { Button, ButtonVariant } from '@/core/components/Button';
import { Paragraph } from '@/core/components/Typography';
import { Icon } from '@/core/components/Icons';
import { useTopmostZIndex } from '@/core/hooks/useTopmostZIndex';

import {
  ButtonsContainer,
  CloseButton,
  ModalContainer,
  ModalHeader,
  TitleWrapper,
} from './SaveAnalysisModal.styles';
import { SaveAnalysisModalProps } from './SaveAnalysisModal.types';

export const SaveAnalysisModal = ({
  isOpen,
  analysisTitle,
  onCancel,
  onConfirm,
}: SaveAnalysisModalProps) => {
  const { colors } = useTheme();
  const zIndex = useTopmostZIndex(isOpen);

  return (
    <Modal
      isOpen={isOpen}
      onClose={onCancel}
      overlayStyle={OverlayStyle.BLUR}
      zIndex={zIndex}
    >
      <ModalContainer>
        <ModalHeader>
          <Paragraph type="bold">{`SAVE ANALYSIS '${analysisTitle}'?`}</Paragraph>
          <CloseButton
            type="button"
            onClick={onCancel}
            aria-label="Close modal"
          >
            <Icon
              name="Close"
              size={14}
            />
          </CloseButton>
        </ModalHeader>
        <TitleWrapper>
          <Paragraph
            type="normal"
            color={colors.secondaryText}
          >
            Saving a report allows you to make further changes.
          </Paragraph>
        </TitleWrapper>
        <ButtonsContainer>
          <Button
            variant={ButtonVariant.PRIMARY}
            onClick={onConfirm}
          >
            YES, SAVE
          </Button>
          <Button
            variant={ButtonVariant.SECONDARY}
            onClick={onCancel}
          >
            CANCEL
          </Button>
        </ButtonsContainer>
      </ModalContainer>
    </Modal>
  );
};
